import { render, staticRenderFns } from "./DataModal.vue?vue&type=template&id=67d84c98&"
import script from "./DataModal.vue?vue&type=script&lang=js&"
export * from "./DataModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67d84c98')) {
      api.createRecord('67d84c98', component.options)
    } else {
      api.reload('67d84c98', component.options)
    }
    module.hot.accept("./DataModal.vue?vue&type=template&id=67d84c98&", function () {
      api.rerender('67d84c98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/prevent/basedata/modules/DataModal.vue"
export default component.exports